/* eslint-disable react/jsx-props-no-spreading */
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import updaetQuery from '@utils/updaetQuery';

const StyledImage = styled(LazyLoadImage)`
  height: 100%;
  width: 100%;
  transform: scale(${({ $noCrop }) => ($noCrop && '1') || '1.02'});
  background-color: #dde6ed;
  object-fit: cover;
`;

const StyledDiv = styled.div`
  height: ${({ orientation }) => orientation === 'vertical' && '152px'};
  width: 272px;
  object-fit: cover;
  position: relative;
  background-color: ${({ theme }) => theme.colors.fontLightBlue};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  overflow: hidden;
`;

const Thumbnail = ({
  imgUrl,
  orientation,
  className,
  children,
  visibleByDefault,
  onClick,
  noCrop,
  borderRadius,
  ...props
}) => {
  const webp = updaetQuery(imgUrl, 'fm', 'webp');
  const imageType = imgUrl?.includes('png') ? 'png' : 'jpg';
  return (
    <StyledDiv
      orientation={orientation}
      className={className}
      onClick={onClick}
      $borderRadius={borderRadius}
      {...props}
    >
      <picture>
        <source srcSet={webp} type="image/webp" />
        <source srcSet={imgUrl} type={`image/${imageType}`} />
        <StyledImage
          visibleByDefault={visibleByDefault}
          src={imgUrl}
          alt=""
          orientation={orientation}
          $noCrop={noCrop}
        />
      </picture>
      {children}
    </StyledDiv>
  );
};

export default Thumbnail;

Thumbnail.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string,
  visibleByDefault: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  noCrop: PropTypes.bool,
  borderRadius: PropTypes.string
};

Thumbnail.defaultProps = {
  orientation: 'vertical',
  className: '',
  visibleByDefault: false,
  onClick: () => {},
  children: null,
  noCrop: false,
  borderRadius: '0px'
};
